import React, { useEffect, useState } from 'react'
import Custombanner from '../../../../assets/img/custom-banner/bg-banner.png';
import icon1 from '../../../../assets/img/custom-banner/icon1.png';
import icon2 from '../../../../assets/img/custom-banner/icon2.png';
import icon3 from '../../../../assets/img/custom-banner/icon3.png';
import icon4 from '../../../../assets/img/custom-banner/icon4.png';
import Time from '../../../../assets/img/custom-banner/time.png';
import Language from '../../../../assets/img/custom-banner/language.png';
import Calendar from '../../../../assets/img/custom-banner/calendar.png';
import UserGroup from '../../../../assets/img/custom-banner/user-group.png';
import { send_Tour_Request } from '../../../../api/global/Global';
import { User_Authentication } from '../../../../user_authentication/User_Authentication';
import { IMG_BASE_URL } from '../../../../config/Config';
import { toast } from 'react-toastify';
import { isValidEmail, isAlphabetical } from '../../../validation/Validation';

const Custom_Banner = ({ tourData }) => {
    const [minTime, setMinTime] = useState("");

    const [showModal, setShowModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [modalForm, setModalForm] = useState({
        name: '',
        email: '',
        phone: '',
        language: "",
        location: '',
        country_code: '+91',// Default country code
        date: '',
        time: ''
    });

    // Handle modal form input changes
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    const handleModalInputChange = (e) => {
        const { name, value } = e.target;

        setErrorMessage("")
        if (name === "phone" && value.length > 10) {
            return
        }

        if (name === "name" && value && !isAlphabetical(value)) {
            setErrorMessage("Name should only contain alphabetic characters");
            return;
        }

        if (name === "email") {
            if (!emailRegex.test(value)) {
                setErrorMessage("Please enter a valid email address");
            } else {
                setErrorMessage("");
            }
        }

        const now = new Date();
        setMinTime(now.toTimeString().slice(0, 5));

        if (name === "time" && value < minTime) {
            setErrorMessage("Please choose a valid future time.");
            return;
        }
        setModalForm(prev => ({
            ...prev,
            [name]: value
        }));
    };


    // Reset messages
    const resetMessages = () => {
        setSuccessMessage('');
        setErrorMessage('');
    };
    // Handle Write to Us button click
    const handleWriteToUs = () => {
        setShowModal(true);
        resetMessages();
    };

    const handleSubmit_Tour = async (e) => {
        e.preventDefault();
        resetMessages();

        if (!modalForm?.email || !isValidEmail(modalForm?.email)) {
            toast("Please enter a valid email address.");
            return;
        }

        try {

            const token = User_Authentication();
            // if (!token) {
            //     // setIsLoading(false);
            //     throw new Error("User token not found");
            // }
            const response = await send_Tour_Request(modalForm, {
                headers: {
                    content: "application/json",
                    // Authorization: `Bearer ${token}`,
                }
            });
            if (response?.data?.status == 200) {
                setSuccessMessage(response?.data?.message);
                setModalForm({
                    name: '',
                    email: '',
                    phone: '',
                    language: "",
                    location: '',
                    date: '',
                    time: ''
                });
                setTimeout(() => {
                    setShowModal(false);
                }, 3000);
            }
            else if (response?.response?.data?.status == 401) {
                setErrorMessage(response?.response?.data?.message);
            } else {
                setErrorMessage('Something went wrong. Please try again later.');
            }
        } catch (error) {
            setErrorMessage(error?.message);
            console.error("Error submitting form:", error);
        }
    };

    useEffect(() => {
        const now = new Date();
        setMinTime(now.toTimeString().slice(0, 5));
    }, [showModal]);

    const closemodal = () => {
        setShowModal(false)
        setModalForm({
            name: '',
            email: '',
            phone: '',
            language: "",
            location: '',
            date: '',
            time: ''
        });
    }
    return (
        <div className="overflow-hidden !bg-no-repeat !bg-center !bg-cover" style={{
            background: `url(${IMG_BASE_URL}${tourData?.banner_image})`,
        }}>
            <div>
                <div className="gi-tab-title grid  lg:grid-cols-3 gap-3 items-center w-full mb-5">
                    <div className="p-4 md:p-12 section-detail col-span-2 lg:max-w-[670px]">
                        <h2 className="bodonibook_font md:text-3xl lg:text-5xl text-white font-bold capitalize">{tourData?.title}</h2>
                        <p className="my-4 text-lg font-semibold text-white capitalize">{tourData?.sub_title}</p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4 mt-3 text-gray-600 text-lg font-medium text-white">
                            <div className='flex gap-3 flex-col items-center'><img src={`${IMG_BASE_URL}${tourData?.image_1}`} alt='' /> <span>{tourData?.title_1}</span></div>
                            <div className='flex gap-3 flex-col items-center'><img src={`${IMG_BASE_URL}${tourData?.image_2}`} alt='' /><span>{tourData?.title_2}</span></div>
                            <div className='flex gap-3 flex-col items-center'><img src={`${IMG_BASE_URL}${tourData?.image_3}`} alt='' /><span>{tourData?.title_3}</span></div>
                            <div className='flex gap-3 flex-col items-center'><img src={`${IMG_BASE_URL}${tourData?.image_4}`} alt='' /><span>{tourData?.title_4}</span></div>
                        </div>
                        <div className='inline-block pt-4 mt-4'>
                            <button type='button' onClick={handleWriteToUs} className="btn text-white font-bold px-8 py-3.5 bg-gradient-to-b from-[#9F2225] to-[#FFB500]">Book Your Tour Now</button>
                        </div>
                    </div>
                    <div className="overflow-hidden lg:col-span-1 col-span-2">
                        <div className='p-4 md:p-12 tour_info relative h-full'>
                            <div className='relative z-10 tour_infotwo space-y-4'>
                                <h3 className="bodonibook_font text-3xl text-white font-bold capitalize">{tourData?.information}</h3>

                                <ul className="space-y-4">
                                    <li className="text-gray-600 text-[14px] font-medium text-white flex gap-3 items-center"><img src={Time} alt='' /> Duration:    {tourData?.duration}</li>
                                    <li className="text-gray-600 text-[14px] font-medium text-white flex gap-3 items-center"><img src={Language} alt='' /> Language: {tourData?.language}</li>
                                    <li className="text-gray-600 text-[14px] font-medium text-white flex gap-3 items-center"><img src={Calendar} alt='' /> {tourData?.days}</li>
                                    <li className="text-gray-600 text-[14px] font-medium text-white flex gap-3 items-center"><img src={UserGroup} alt='' /> Group Size: {tourData?.group_size}</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className={`p-10 ${!showModal ? 'hidden' : 'block'} fixed inset-0 z-30 bg-gray-950/90 h-full overflow-hidden`}>
                {/* <button
                        onClick={() => setShowModal(true)}
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                        Open Modal
                    </button> */}
                <div className="flex h-full justify-center items-center">
                    <div className="mx-auto bg-white p-5 w-[500px] rounded relative">
                        <div isOpen={showModal} onClose={() => setShowModal(false)}>
                            <button
                                onClick={closemodal}
                                className="absolute -top-4 -right-4 font-bold text-xl bg-red-700 text-white w-8 h-8 text-center inline-block rounded-full pb-1 border border-white">x</button>
                            <div>
                                <h3 className="text font-semibold">Step Inside the World of
                                    Timeless Craftsmanship</h3>

                            </div>
                            <div className="grid grid-cols-1 gap-3">
                                {/* <div>
                                        <img className="w-full" src={`${IMG_BASE_URL}${selectedDesignId?.thumbnail_img}`} alt="jewellery" />
                                    </div> */}
                                <div>
                                    <form className=" " onSubmit={handleSubmit_Tour} method='post' >
                                        <div className="w-full px-[6px] mb-1">
                                            <label
                                                className="text-gray-700 font-medium text-[12px] inline-block">User Name</label>
                                            <input type="text"
                                                placeholder="Enter your name"
                                                name="name"
                                                value={modalForm.name}
                                                onChange={handleModalInputChange}
                                                className="input-field text-[12px] w-full border border-gray-200 px-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[33px]"
                                                required />
                                        </div>


                                        <div className="w-full px-[6px] mb-1">
                                            <label
                                                className="text-gray-700 font-medium text-[12px] inline-block">Email ID </label>
                                            <input type="email"
                                                name="email"
                                                placeholder="Enter your e-mail here"
                                                value={modalForm.email}
                                                onChange={handleModalInputChange}
                                                className="input-field text-[12px] w-full border border-gray-200 px-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[33px]"
                                                required />
                                        </div>
                                        <div className="w-full px-[6px] mb-1">
                                            <label
                                                className="text-gray-700 font-medium text-[12px] inline-block">Phone Number </label>
                                            <input type="number"
                                                name="phone"
                                                placeholder="Enter Your Phone Number Here"
                                                value={modalForm.phone}
                                                onChange={handleModalInputChange}
                                                className="input-field text-[12px] w-full border border-gray-200 px-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[33px]"
                                                required />
                                        </div>
                                        <div className="w-full px-[6px] mb-1">
                                            <label
                                                className="text-gray-700 font-medium text-[12px] inline-block">Language</label>
                                            <input type="text"
                                                placeholder="Enter your language"
                                                name="language"
                                                value={modalForm.language}
                                                onChange={handleModalInputChange}
                                                className="input-field text-[12px] w-full border border-gray-200 px-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[33px]"
                                                required />
                                        </div>
                                        <div className="w-full px-[6px] mb-1">
                                            <label
                                                className="text-gray-700 font-medium text-[12px] inline-block">Location</label>
                                            <input type="text"
                                                placeholder="Enter your location"
                                                name="location"
                                                value={modalForm.location}
                                                onChange={handleModalInputChange}
                                                className="input-field text-[12px] w-full border border-gray-200 px-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[33px]"
                                                required />
                                        </div>
                                        <div className="w-full px-[6px] mb-1 flex gap-3">
                                            <div className='w-1/2'>
                                                <label
                                                    className="text-gray-700 font-medium text-[12px] inline-block">Date</label>
                                                <input type="date"
                                                    placeholder="Choose Date"
                                                    name="date"
                                                    value={modalForm.date}
                                                    min={new Date().toISOString().split("T")[0]}
                                                    onChange={handleModalInputChange}
                                                    className="input-field text-[12px] w-full border border-gray-200 px-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[33px]"
                                                    required />
                                            </div>
                                            <div className='w-1/2'>
                                                <label
                                                    className="text-gray-700 font-medium text-[12px] inline-block">Time</label>
                                                <input type="time"
                                                    placeholder="Choose Time"
                                                    name="time"
                                                    value={modalForm.time}
                                                    min={minTime}
                                                    onChange={handleModalInputChange}
                                                    className="input-field text-[12px] w-full border border-gray-200 px-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[33px]"
                                                    required />
                                            </div>
                                        </div>
                                        <div className="w-full px-[6px] mb-1">

                                        </div>



                                        {successMessage && (
                                            <div className="bg-green-100 border border-green-400 text-green-700 px-3 py-2 mx-[6px] rounded text-xs">
                                                {successMessage}
                                            </div>
                                        )}

                                        {errorMessage && (
                                            <div className="bg-red-100 border border-red-400 text-red-700 px-3 py-2 mx-[6px] rounded text-xs">
                                                {errorMessage}
                                            </div>
                                        )}

                                        <div className="w-full px-[6px] mt-4">
                                            <button type="submit"
                                                // disabled={loading}
                                                className="text-[12px] mx-auto w-full uppercase inline-block border border-red-700 bg-red-700 text-white font-semibold px-6 py-2 hover:bg-red-700 hover:text-white">
                                                SUBMIT
                                                {/* {loading ? 'SUBMITTING...' : 'SUBMIT'} */}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Custom_Banner